import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import clsx from 'clsx';
import React, { forwardRef, useRef, useEffect } from 'react';
import mergeRefs from 'react-merge-refs';
import defaultStyles from './styles/Avatar.module.scss.js';
import { autoFixFontSizeHandler } from './utils/autoFixFontSizeHandler.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const Avatar = /*#__PURE__*/forwardRef((props, ref) => {
  const Component = 'div';
  const textRef = useRef(null);
  const avatarRef = useRef(null);
  const {
    theme,
    variant = 'circle',
    size = 'sm',
    children,
    autoFixFontSize = true,
    onClick,
    dataTestId,
    ...rest
  } = props;
  const isImage = children && /*#__PURE__*/React.isValidElement(children) && (children.type === 'img' || children.type === 'picture' || children?.props?.mdxType);
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  const sizeClass = {
    [styles.xs]: size === 'xs',
    [styles.sm]: size === 'sm',
    [styles.md]: size === 'md',
    [styles.lg]: size === 'lg',
    [styles.xl]: size === 'xl'
  };
  const variantClass = {
    [styles.circle]: variant === 'circle',
    [styles.square]: variant === 'square'
  };
  const componentProps = {
    'data-test-id': dataTestId,
    className: clsx(styles.root, variantClass, sizeClass)
  };
  useEffect(() => {
    if (autoFixFontSize) {
      autoFixFontSizeHandler(textRef, avatarRef);
    }
  }, [textRef, avatarRef]);
  return /*#__PURE__*/jsxs(Component, {
    ref: mergeRefs([avatarRef, ref]),
    onClick: onClick,
    ...rest,
    ...componentProps,
    children: [isImage ? /*#__PURE__*/jsx("span", {
      className: styles.image,
      children: children
    }) : null, !isImage && /*#__PURE__*/jsx("span", {
      ref: textRef,
      className: styles.text,
      children: children
    })]
  });
});
Avatar.displayName = 'Avatar';

export { Avatar };
